import { observable, makeObservable } from 'mobx';
import { API_REQUEST_ERROR, API_REQUEST_SUCCEEDED, API_REQUESTING } from './api';

class PaymentStore {
  constructor(api) {
    this.paymentDetails = null;
    this.repayStatus = null;
    this.payeeInfo = null;
    this.earlyPayoutStatus = {};
    this.advancedPayoutStatus = {};
    this.customPayoutStatus = {};
    this.unresolvedPayments = null;

    makeObservable(this, {
      paymentDetails: observable,
      repayStatus: observable,
      payeeInfo: observable,
      earlyPayoutStatus: observable,
      advancedPayoutStatus: observable,
      customPayoutStatus: observable,
      unresolvedPayments: observable,
    });
    this.api = api;
  }

  getPaymentDetails(paymentId) {
    this.api.get(`/driver-payments/${paymentId}`).then((response) => {
      if (response.status === 200) {
        this.paymentDetails = response.data;
      }
    });
  }

  getPayeeDetails(paymentId) {
    this.api.get(`/driver-payments/${paymentId}/payee-info`).then((response) => {
      if (response.status === 200) {
        this.payeeInfo = response.data;
      }
    });
  }

  getDspPaymentCSV(paymentId) {
    return this.api.get(`/dsp-payments/${paymentId}/csv`).then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return null;
      }
    });
  }

  getDspPaymentDetails(paymentId) {
    this.api.get(`/dsp-payments/${paymentId}`).then((response) => {
      if (response.status === 200) {
        const data = response.data;

        if (data.contractor_transactions && data.delivery_surcharge_payouts) {
          data.contractor_transactions.forEach((transaction) => {
            if (transaction.type === 'OUTVOICE - SURCHARGE') {
              const matchingPayouts = data.delivery_surcharge_payouts.filter((payout) => payout.transaction_id === transaction.id);

              const driverGroups = {};
              matchingPayouts.forEach((payout) => {
                const driverId = payout.driver_id;
                if (!driverGroups[driverId]) {
                  driverGroups[driverId] = {
                    driver_id: driverId,
                    driver_name: payout.driver_name || '-',
                    total_amount: 0,
                    assignment_ids: new Set(),
                    count: 0,
                  };
                }

                driverGroups[driverId].total_amount += payout.amount || 0;
                if (payout.assignment_id) {
                  driverGroups[driverId].assignment_ids.add(payout.assignment_id);
                }
                driverGroups[driverId].count += 1;
              });

              transaction.driverGroups = Object.values(driverGroups).map((group) => ({
                ...group,
                assignment_ids: Array.from(group.assignment_ids).join(', '),
              }));
            }
          });
        }

        this.paymentDetails = data;
      }
    });
  }

  getDspDetails(paymentId) {
    this.api.get(`/dsp-payments/${paymentId}/payee-info`).then((response) => {
      if (response.status === 200) {
        this.payeeInfo = response.data;
      }
    });
  }

  getUnresolvedPayments() {
    this.api.get(`/driver-payments/unresolved`).then((response) => {
      if (response.status === 200) {
        this.unresolvedPayments = response.data;
      }
    });
  }

  resetStatuses() {
    this.advancedPayoutStatus = {};
  }
}

export default PaymentStore;
